import React, { useState } from 'react';
import Wrapper from 'ui/Wrapper';
import styled from 'styled-components';
import mainBg from 'images/banners/unsubscribe_bg.jpeg';
import Text from 'ui/Text';
import Button from 'ui/Button';
import UserService from 'utils/UserService';
import { detectError } from 'utils/Helper';
import { NotificationManager } from 'react-notifications';
import { browserHistory } from 'react-router';

const MainImg = styled.img.attrs({
    src: mainBg,
})`
    width: 100%;
    height: 400px;
    object-fit: cover;
    max-height: 30vh;
    background-position: center;
`;
const MainTextWrapper = styled(Wrapper)`
    width: 600px;
    margin: 50px auto;
    max-width: 90%;
`;
const Resubscribe = styled.span`
    color: #333;
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
    display: inline-block;
`;
const List = styled.ul`
    padding: 10px 10px 10px 15px;
    li {
        line-height: 21px;
        list-style: disc;
        font-size: 16px;
        color: #333;
    }
`;

const StyledInput = styled.input.attrs({ type: 'email' })`
    border-radius: 5px;
    border: 1px solid #e2e2e2;
    background: #f6f8fb;
    color: #333;
    font-size: 21px;
    line-height: 28px;
    width: 480px;
    max-width: 90%;
    padding: 5px 10px;
    &::placeholder {
        color: #757575;
    }
`;

const UnsubscribePage = () => {
    const [subscribed, setSubscribed] = useState(true);
    const [isValid, setIsValid] = useState(true);
    const [email, setEmail] = useState('');

    const emailRegEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const unsubscribe = () => {
        if (isValid && email) {
            UserService.UnsubscribeFromNewsletter(0, email)
                .then((res) => {
                    if (!res.success) {
                        NotificationManager.error(
                            detectError(res.errorMessage)
                        );
                    } else {
                        setSubscribed(false);
                        setEmail('');
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            NotificationManager.error('Ugyldig email');
        }
    };
    const resubscribe = () => {
        UserService.NewsletterSubscription(1).then((res) => {
            if (res.success) {
                NotificationManager.success(
                    'Du er nu tilmeldt vores nyhedsbrev'
                );
                browserHistory.push('/sport/');
            }
        });
    };
    const validate = () => {
        if (email && !email.match(emailRegEx)) {
            setIsValid(false);
        } else {
            setIsValid(true);
        }
    };

    return subscribed ? (
        <Wrapper padding="0">
            <MainImg />
            <MainTextWrapper>
                <Text size="24" bold color="#333" lh="21">
                    AFMELD BET25’S NYHEDSBREV
                </Text>
                <Text size="x15" color="#333" lh="21">
                    Vi er kede af, at du ikke længere ønsker at modtage Bet25’s
                    nyhedsbrev. Du har ellers en række fordele, når du er
                    tilmeldt Bet25’s nyhedsbrev. Så er du nemlig sikker på altid
                    at få seneste nyt fra Bet25 direkte i din indbakke, såsom:
                </Text>
                <List>
                    <li>Kampagner om ekstra bet- og livebet-tilbud</li>
                    <li>Konkurrencer</li>
                    <li>Skarpe odds og spilanbefalinger</li>
                    <li> Vigtig produktinformation</li>
                </List>
                <Text size="x15" color="#333" lh="21">
                    Alt dette går du glip af, hvis du ikke længere modtager
                    Bet25’s nyhedsbrev.
                </Text>
                <Text size="x15" bold color="#333" lh="21">
                    Ønsker du fortsat at afmelde dig Bet25’s nyhedsbrev?
                </Text>
                <Text color="#333" bold size="x15" lh="21">
                    Email adresse
                </Text>
                <StyledInput
                    placeholder="Email adresse"
                    value={email}
                    onBlur={validate}
                    onChange={(e) => {
                        setEmail(e.target.value);
                    }}
                />
                <Button
                    onClick={unsubscribe}
                    margin="10px 10px 10px 0"
                    display="inline-block"
                    width="150px"
                    active
                    bold
                    fontSize="20px"
                >
                    Afmeld
                </Button>
                <Button
                    onClick={() => {
                        browserHistory.push('/sport/');
                    }}
                    display="inline-block"
                    width="150px"
                    grey
                    bold
                    fontSize="20px"
                >
                    Annuller
                </Button>
            </MainTextWrapper>
        </Wrapper>
    ) : (
        <MainTextWrapper>
            <Text size="24" color="#489260" lh="21" bold padding="70px 0 30px">
                DU ER NU AFMELDT
            </Text>
            <Text size="x15" color="#333" lh="21">
                Vi sender fra i dag ikke flere nyhedsbreve til tilbud og
                kampagner til din mailboks.
            </Text>
            <Text size="x15" color="#333" lh="21">
                Har du fortrudt?{' '}
                <Resubscribe onClick={resubscribe}>Tilmeld igen</Resubscribe>
            </Text>
            <Button
                onClick={() => {
                    browserHistory.push('/sport/');
                }}
                margin="40px 10px 10px 0"
                active
                bold
                fontSize="20px"
            >
                Tilbage til forsiden
            </Button>
        </MainTextWrapper>
    );
};

export default UnsubscribePage;
